import { getExternalLinkAccessPoolName } from './getExternalLinkAccessPoolName';

/**
 * Filters external app links by user apps and excludes the current app.
 * @param {Array<{ poolName: string }>} links all possible external links
 * @param {Array<{ poolName: string, enabled?: boolean }>} apps user apps from profile
 * @param {string} currentPoolName auth poolName of the current app
 * @returns {Array} links that should be rendered
 */
export const filterExternalLinks = (
  links = [],
  apps = [],
  currentPoolName = ''
) => {
  const availablePoolNames = new Set(
    (apps || [])
      .filter(app => app?.enabled !== false)
      .map(app => app?.poolName)
      .filter(Boolean)
  );
  const currentAccessPoolName = getExternalLinkAccessPoolName(currentPoolName);

  return (links || []).filter(link => {
    const linkAccessPoolName = getExternalLinkAccessPoolName(link.poolName);

    return (
      availablePoolNames.has(linkAccessPoolName) &&
      linkAccessPoolName !== currentAccessPoolName
    );
  });
};
